/**
 * Benefits for draw-protection variant (matching the design mockup)
 */
const DRAW_PROTECTION_BENEFITS = [
  'Early access to new properties.',
  'Unlimited Buck trip planning + Q&A.',
  'Auto-entry in every Dream Hunt Sweepstakes.',
];

/**
 * Benefits for general variant (matching landtrust-ui membership page)
 */
const GENERAL_BENEFITS = [
  'Draw Protection on draw-required hunts.',
  'Early access to new properties.',
  'Unlimited Buck trip planning + Q&A.',
  'Auto-entry in every Dream Hunt Sweepstakes.',
];

/**
 * Variant-specific content for the LT Plus drawer
 * Maps backend variants to drawer headline, promo content, and CTA text
 */
export const VARIANT_CONTENT: Record<
  string,
  {
    headline: string;
    promoTitle?: string;
    promoDescription?: string;
    promoDescriptionExtra?: string;
    benefitsHelperText?: string;
    ctaText: string;
    showPromoBox: boolean;
    benefits: string[];
  }
> = {
  'draw-protection': {
    headline: 'Found the right property but still waiting on the draw?',
    promoTitle: 'Get peace of mind while you wait.',
    promoDescription: "Book now. If you don't draw, get a full refund (minus processing fees).",
    promoDescriptionExtra: undefined,
    benefitsHelperText: 'Both Plans Include',
    ctaText: 'Add Draw Protection',
    showPromoBox: true,
    benefits: DRAW_PROTECTION_BENEFITS,
  },
  general: {
    headline: 'Unlock more with LandTrust Plus!',
    promoTitle: 'Get More Value From Every Hunt',
    promoDescription:
      'LandTrust Plus helps you book with confidence, plan smarter, and get more from every trip.',
    benefitsHelperText: 'Your subscription includes',
    ctaText: 'Upgrade to LandTrust Plus',
    showPromoBox: true,
    benefits: GENERAL_BENEFITS,
  },
};
